import Button from '@components/ui/button.vue';
import MovingImage from '@components/ui/movingimage.vue';

export default {
  components: {
    't-button': Button,
    't-image': MovingImage,
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/about-main-page/script.js